import { api } from './api';

export async function saveCanvas(courseId: number, nodeId: number, blocks: string): Promise<void> {
  await api.put(`/api/tutor/courses/${courseId}/nodes/${nodeId}/canvas`, { blocks });
}

export async function loadCanvas(courseId: number, nodeId: number): Promise<string | null> {
  try {
    const response = await api.get<{ data: { blocks: string } }>(
      `/api/tutor/courses/${courseId}/nodes/${nodeId}/canvas`
    );
    return response.data.data?.blocks ?? null;
  } catch (err: any) {
    if (err?.response?.status === 204) return null;
    throw err;
  }
}
